import { BrowserEventEmitter } from "features/ui/Filters/BrowserEventEmitter";
import { DEFAULT_FILTER_BUILDER_STATE } from "features/ui/Filters/FilterBuilder/constants";
import { UseFilterSortState } from "features/ui/Filters/types";

export const getSchemaEventAnalyticsPageKey = (schemaName: string) =>
  `schema-event-analytics-${schemaName}`;

export const EVENTS_TAB_KEY = "events";
export const TOP_CONTRIBUTORS_TAB_KEY = "topContributors";
export const BY_ASSET_AGE_TAB_KEY = "byAssetAge";
export const ASSOCIATED_ASSETS_TAB_KEY = "associatedAssets";
export const ASSOCIATED_EVENTS_TAB_KEY_PREFIX = "associatedEvents";

export const EMPTY_FILTER_SORT_STATE: UseFilterSortState = {
  initialized: false,
  sort: undefined,
  manageOnSortChange: () => {},
  advancedFilters: DEFAULT_FILTER_BUILDER_STATE,
  quickFilters: [],
  updateQuickFilters: () => {},
  filters: DEFAULT_FILTER_BUILDER_STATE,
  updateFilters: () => {},
  visibleFilters: DEFAULT_FILTER_BUILDER_STATE,
  manageFilterChange: () => {},
  resetFilters: () => {},
  resetSort: () => {},
  resetFilterSortState: () => {},
  failureModeColumns: [],
  manageOnVisibleFMColumnChange: () => {},
  isAdvancedFilterEditor: false,
  setIsAdvancedFilterEditor: () => {},
  toggleQuickFilters: () => {},
  restoreDefaults: () => {},
  associatedVehiclesState: undefined,
  manageAssociatedVehiclesStateChange: () => {},
  eventEmitter: { current: new BrowserEventEmitter() },
  filtersQuery: "",
};
